import React from 'react'
import './consulting-content.scss'
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb'
import HeaderConsulting from '../../molecules/header-consulting/header-consulting';
import BodyConsulting from '../../molecules/body-consulting/body-consulting';
import FooterConsulting from '../../molecules/footer-consulting/footer-consulting';

const ConsultingContent = (props) => {
    const {mobile, params} = props;

    return (
        <div className="f-consulting-content">
            <div className="f-breadcrum-position">
                <Breadcrumb mobile={mobile} />
            </div>
            <HeaderConsulting mobile={mobile} banner={params.banner.bannerSecciones}/>
            <BodyConsulting mobile={mobile} params={params}/>
            <FooterConsulting mobile={mobile} params={params}/>
        </div>
    )
}

export default ConsultingContent
